import { cloneDeep } from "lodash";
import type { ParametricAsset } from "@/types";
import slabBridgeExtrados from "./slab-bridge-extrados";
import slabBridgeIntrados from "./slab-bridge-intrados";
import abutment from "./abutment";
import wingWall from "./wing-wall";
import trapezoidalPier from "./trapezoidal-pier";
import cantilever from "./cantilever";
import cantilever2 from "./cantilever-2";
import cantilever3 from "./cantilever-3";
import cantileverReinforcement from "./cantilever-reinforcement";

import culvertUnfoldedView from "./culvert-unfolded-view";
import culvertHeadwall from "./culvert-headwall";
import beamBridge from "./beam-bridge";
import tunnelHead from "./tunnel-head";
import rectangle from "./rectangle";

export const DR_ASSETS: ParametricAsset<any>[] = [
  rectangle,
  slabBridgeExtrados,
  slabBridgeIntrados,
  abutment,
  wingWall,
  trapezoidalPier,
  cantilever,
  cantilever2,
  cantilever3,
  cantileverReinforcement,
  culvertHeadwall,
  culvertUnfoldedView,
  beamBridge,
  tunnelHead,
];

export default class AssetLibrary {
  static getAll() {
    return cloneDeep(DR_ASSETS);
  }

  static getById(id: string) {
    for (const asset of DR_ASSETS) {
      if (asset.id === id) return cloneDeep(asset);
    }
    return undefined;
  }
}
